import PageLoadedQueue from "./PageLoadedQueue";

/**
 * Make header sticky
 */
(function (PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const sticky = document.querySelector('.header--fixable');

        if (sticky) {
            const stickyHeader = () => {
                const mediaBreakpointUpLg = window.matchMedia('(min-width: 992px)').matches;

                if (mediaBreakpointUpLg && window.scrollY >= 35) {
                    sticky.classList.add('is-fixed');
                } else {
                    sticky.classList.remove('is-fixed');
                }
            };

            stickyHeader();
            window.addEventListener('resize', stickyHeader, {passive: true});
            window.addEventListener('scroll', stickyHeader, {passive: true});
        }
    });
})(window.PageLoadedQueue);
